import classNames from "classnames";
import styles from "@/elements-react/product-element-refactor/product-element.module.scss";
import { testid } from "@fixparts/testid/index";
import { HasPropertyType } from "@/elements-react/product-element-refactor/useProductElement";
import { ProductStateType } from "@/util/constants";
import { CurrencyConverter } from "@/util/currency-converter";
import { useServices } from "@/services-context";

interface ProductElementPriceProps {
  availableForOrder: boolean;
  hasPrice: boolean;
  priceText: string;
}

export interface ProductElementPriceFactoryProps {
  state: number;
  price: [number, number];
}

export const productElementPricePropsFactory = (
  props: ProductElementPriceFactoryProps & { hasProperty: (type: HasPropertyType) => boolean },
): ProductElementPriceProps => {
  const { hasProperty, state, price } = props;
  const { formatter } = useServices();

  const availableForOrder = hasProperty("hasPrice") && state === ProductStateType.Active && !hasProperty("outOfStock") && !hasProperty("onRequest");

  const from = price[0];
  const to = price[1] ?? from;
  const priceText = formatter.priceRange([CurrencyConverter.convertCents(from), CurrencyConverter.convertCents(to)]);

  return {
    availableForOrder,
    hasPrice: hasProperty("hasPrice"),
    priceText,
  };
};

export const ProductElementPrice = (props: ProductElementPriceProps) => {
  const { availableForOrder, hasPrice, priceText } = props;

  return (
    <div className={classNames(styles.price, !availableForOrder && styles.disabled)} {...testid({ block: "productCard", elm: "line", modifier: "price" })}>
      {hasPrice && priceText}
    </div>
  );
};
